const Origin = {
  ORIGIN_ITEM_ADDING: 'origin/add',
  ORIGIN_ITEM_UPDATE: 'origin/update',
  ORIGIN_ITEM_STATUS_UPDATE: 'origin/status_update',
};

export default Origin;
